import { all } from 'redux-saga/effects';
import watchCreateCompanySagas from '../pages/createCompany/sagas/index';

export default function* sagas() {
    yield all([watchCreateCompanySagas()]);
}
